import PropTypes from "prop-types";

import React from "react";

// import { withRouter, matchPath } from "react-router";

import Link from "../../Link";
// ^^ A Link element for our custom history router.

import SEO from "../../../../../global-components/seo";

import * as ROUTES from "../../../constants/routes.js";

import "./style.scss";

class FormRow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      //
    };

    this.vars = {
      //
    };
  }

  componentDidMount() {
    // this.timerID = setInterval(() => this.tick(), 1000);

    this.init();
  }

  componentWillUnmount() {
    // clearInterval(this.timerID);
  }

  componentDidUpdate(prevProps) {
    var Z = this;
    /* if (this.props.currentRoute !== prevProps.currentRoute) {
            Z.loadPage();
        } */
  }

  init = () => {
    const Z = this;

    // Z.loadPage();
  };

  render() {
    var Z = this;

    return (
      <div className={`FormRow ${Z.props.className || ""}`} style={Z.props.style || {}}>
        {Z.props.children != null && Z.props.children.length > 0
          ? Z.props.children.map((child, childIndex) => {
              return (
                <child.type
                  key={childIndex}
                  {...child.props}
                  formValues={Z.props.formValues}
                  formErrors={Z.props.formErrors}
                  fieldTypes={Z.props.fieldTypes}
                  updateFormValue={Z.props.updateFormValue}
                  validateForm={Z.props.validateForm}
                >
                  {React.Children.toArray(child.props.children)}
                </child.type>
              );
              // return child;
            })
          : null}
      </div>
    );
  }
}

FormRow.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  // children: PropTypes.object,
  // children: PropTypes.arrayOf(PropTypes.node),
  // children: PropTypes.arrayOf(PropTypes.any),
  formValues: PropTypes.object,
  formErrors: PropTypes.object,
  fieldTypes: PropTypes.object,
  updateFormValue: PropTypes.func,
  validateForm: PropTypes.func,
};

export default FormRow;
